import _ from 'lodash';
import { makeReactive } from '@dha/make-reactive';
import SectionModel from './SectionModel';

export default class CategoryModel {
    constructor(parent, options) {
        this.parent = parent;
        this.options = options;
    }

    get id() {
        return this.options.id;
    }

    get domId() {
        return _.kebabCase(this.id);
    }

    get title() {
        return this.options.title;
    }

    get description() {
        return this.options.description;
    }

    get sectionModels() {
        return this.options.sections.map(section => {
            if (typeof section === 'string') {
                return makeReactive(new SectionModel(
                    this.parent,
                    section,
                    this.parent.sectionConfig[section]
                ));
            }
            return section;
        });
    }
}
